export default __webpack_public_path__ + "static/media/paper-on.7fb35100.png";